import Vue from 'vue'
import Vuex from 'vuex'
import * as firestore from './firestore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    firestore: { namespaced: true, ...firestore },
  },
})
